export function extractVideoIdFromYoutubeUrl(url: string): string {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtu\.be\/|youtube\.com\/(embed\/|v\/|watch\?v=|shorts\/))([\w-]{11})(?:[?&\w=]*)?$/;    const videoId = url.match(youtubeRegex)?.[5] ?? '';
    return videoId;
}

export const isS3Url = (url: string): boolean => url.includes('s3.gra.io.cloud.ovh.net');